<!--追加费用-->
<template>
    <div class="content-panel">
        <el-row :gutter="10" type="flex" justify="space-between" align="middle" class="breadcrumb-wrap">
            <el-col :span="20">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">{{msg('首页')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{msg('追加费用')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row :gutter="10"  class="ctrl-wrap">
            <el-col :sm="24" :md="12">
                <el-button size="mini"
                    @click="doSelectFile()" type="success"
                    style="margin-right:5px; margin-bottom:5px;">
                        <i class="iconfont icon-xuanzewenjian"
                            style="display:inline-block;margin-right:4px;"></i>
                        <transition name="el-fade-in-linear">
                            <span v-show="!isMinScreen">{{msg('上传文件')}}</span>
                        </transition>
                </el-button>

                <div ref="fileArea" style="display:none;">
                </div>
            </el-col>
            <el-col :sm="24" :md="12">
                <el-button size="mini"
                    @click="doDownloadTpl()" type="primary"
                    style="margin-right:5px; margin-bottom:5px;">
                        <i class="el-icon-download" style="display:inline-block;margin-right:4px;"></i>
                        <transition name="el-fade-in-linear">
                            <span v-show="!isMinScreen">{{msg('下载模板')}}</span>
                        </transition>
                </el-button>
            </el-col>
        </el-row>
        <el-row :gutter="15">
            <el-table :data="results" :height="docHeight" style="width: 100%" size="mini" ref="dataTable" stripe>
                <el-table-column type="index" width="50"></el-table-column>
                <el-table-column prop="orderCode" :label="msg('订单编号')" min-width="160" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="amount" :label="msg('金额(元)')" min-width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="settleAccount" :label="msg('结算账号')" min-width="120" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="remark" :label="msg('处理结果')" min-width="200" :show-overflow-tooltip="true"></el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<script>
import XLSX from "xlsx";
export default {
    name: 'WalletAppendFee',
    components: {},
    data(){
        return {
            excelHeads: [], //从excel解析出数据的表头
            excelData: null, //从excel解析出的数据
            results:[],
        }
    },
    computed: {
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
    },
    methods:{
        doSelectFile(){  //点击选择文件
            this.$refs.fileArea.innerHTML = "";
            var input = document.createElement("input");
            input.type="file";
            input.onchange=this.getUploadFile;
            this.$refs.fileArea.appendChild(input);
            input.click();
        },
        getUploadFile(e) {  //解析上传的excel
            let that = this;

            this.excelData = null
            //拿到所导入文件的名字
            let fileName = e.target.files[0];
            //定义reader，存放文件读取方法
            let reader = new FileReader();
            //启动函数
            reader.readAsBinaryString(fileName)
            //onload在文件被读取时自动触发
            reader.onload = (e) => {
                //workbook存放excel的所有基本信息
                let workbook = XLSX.read(e.target.result, {type: 'binary'})
                //定义sheetList中存放excel表格的sheet表，就是最下方的tab
                let sheetList = workbook.SheetNames
                //存放json数组格式的表格数据
                let worksheet = workbook.Sheets[workbook.SheetNames[0]];
                let json = XLSX.utils.sheet_to_json(worksheet, {header:1})

                var heads = json[0];
                that.excelData = json.splice(1);
                that.excelHeads = heads;
                that.$refs.fileArea.innerHTML = "";
                this.doUpload();
            };
        },
        doDownloadTpl(){  //下载一个excel模板，列为追加费用对账表头

            var titles = [['揽收时间','结算账号','备注','归属人','订单编号','查询码','代收货款','实际回款（台币）','货物品名','重量(KG)','单价（元/KG）','空运费(元）','交派费（元）','超才费（元）','打包费（元）','空包费（元）','转寄费（元）','派件费（台币）','代收手续费（台币）','海快税金（台币）','续仓费（台币）','附加费（台币）','偏远附加费','汇率','总费用','配送方式','运输方式','收件人','收件人地址','批次','归属公司','店铺名','组织','出货仓库','目的地']];

            var filename = '追加费用导入模板.xlsx';

            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.aoa_to_sheet(titles);

            XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
            XLSX.writeFile(wb, filename);
        },
        doUpload(){
            this.$axios.post(this.$kit.api.wallet.doAppendFee, this.excelData)
                .then((result) => {
                    if(result.status){
                        this.results = (result.data || []).map(r => ({
                            orderCode: r.orderCode,
                            settleAccount: r.settleAccount,
                            amount: Number(r.amount || 0).toFixed(2),
                            remark: r.remark
                        }));
                    }
                });
        },
    }
}
</script>
<style lang="scss" scoped>

</style>
